import { BusinessCategory } from '../businessCategory'

export class MusicProfile {
	id: number
	accountId: number
	businessCategoryId: number
	brandIdentityIds: number[]
	name: string
	data: MusicProfileData

	businessCategory?: BusinessCategory

	constructor(data: {
		id: number
		accountId: number
		businessCategoryId: number
		brandIdentityIds: number[]
		name: string
		data: MusicProfileData
	}) {
		this.id = data.id
		this.accountId = data.accountId
		this.businessCategoryId = data.businessCategoryId
		this.brandIdentityIds = data.brandIdentityIds
		this.name = data.name
		this.data = data.data
	}

	static create(data: Partial<MusicProfile>): MusicProfile {
		const defaultValues = {
			id: 0,
			accountId: 0,
			businessCategoryId: 0,
			brandIdentityIds: [],
			name: '',
			data: MusicProfileData.create(data.data ?? {}),
		}

		return new MusicProfile({ ...defaultValues, ...data })
	}
}

export class MusicProfileData {
	culturalIdentity: string
	ageGroups: string[]
	gender: string
	socioeconomicGroups: string[]
	preferredGenres: string[]
	unwantedGenres: string[]
	busiestTimeframes: {
		[key: string]: {
			end: string
			start: string
		}[]
	}

	constructor(data: {
		culturalIdentity: string
		ageGroups: string[]
		gender: string
		socioeconomicGroups: string[]
		preferredGenres: string[]
		unwantedGenres: string[]
		busiestTimeframes: {
			[key: string]: {
				end: string
				start: string
			}[]
		}
	}) {
		this.culturalIdentity = data.culturalIdentity
		this.ageGroups = data.ageGroups
		this.gender = data.gender
		this.socioeconomicGroups = data.socioeconomicGroups
		this.preferredGenres = data.preferredGenres
		this.unwantedGenres = data.unwantedGenres
		this.busiestTimeframes = data.busiestTimeframes
	}

	static create(data: Partial<MusicProfileData>): MusicProfileData {
		const defaultValues = {
			culturalIdentity: '',
			ageGroups: [],
			gender: '',
			socioeconomicGroups: [],
			preferredGenres: [],
			unwantedGenres: [],
			busiestTimeframes: {},
		}
		return new MusicProfileData({ ...defaultValues, ...data })
	}
}
